import { useCallback } from "react";
import { AlphabetCollectionsDraftApi, useAPIAction } from "melco-shared-logic";

export const useDeleteFontCollections = () => {
  const [deleteFontCollection] = useAPIAction(
    AlphabetCollectionsDraftApi,
    async (api, id: string) => {
      const data = await api.userAlphabetCollectionsDelete({ id, force: true });
      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "font_collections.actions.delete",
    }
  );

  return useCallback(
    async (fontCollectionIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const fontCollectionId of fontCollectionIds) {
        try {
          await deleteFontCollection(fontCollectionId);
          successfullyDeleted.push(fontCollectionId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteFontCollection]
  );
};
